import React, { useState, useEffect } from 'react';
import { profileStore } from 'src/hooks/profile';
import Constants from 'src/helper/Constants';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import Helper from 'src/helper/Helper';
import System from 'src/helper/system';

const VerifyAddressPopup = (props) => {
  const { data, SetStatus } = props;
  const [selectedAddressIndex, setSelectedAddressIndex] = useState(0);
  const [address, setAddress] = useState(data?.suggestedAddress[0]);
  const [isAddressInfoEmpty, setIsAddressInfoEmpty] = useState(address?.isAddressInfoEmpty)
  const [addType, setAddType] = useState(address?.addressType)

  const [{ }, { get_profile_account_information }, { add_profile_address, edit_profile_invoice_address }] = profileStore();
  const { addressType,siteUser } = Constants;
  const [{ }, { system_alert_indicator }] = useDOMAttachToSystemStore();
  const isWebUser = System.avUserInfoData.currentUser === siteUser.WEB

  useEffect(() => {
    if (selectedAddressIndex === -1) {
      setAddress(data?.enteredAddress);
      setIsAddressInfoEmpty(data?.enteredAddress?.isAddressInfoEmpty)
      setAddType(data?.enteredAddress?.addressType)
    } else {
      setAddress(data?.suggestedAddress[selectedAddressIndex]);
      setIsAddressInfoEmpty(data?.suggestedAddress[selectedAddressIndex]?.isAddressInfoEmpty)
      setAddType(data?.suggestedAddress[selectedAddressIndex]?.addressType)
    }
  }, [selectedAddressIndex, data]);

  const onSaveAddress = async () => {
    const req = {
      companyName: address?.company,
      addressLineOne: address?.address1,
      addressLineTwo: address?.address2,
      cityName: address?.city,
      stateCode: address?.stateCode,
      postalCode: address?.postalCode,
      countryCode: address?.countryCode,
      addressType: addType,
      id: address?.id
    };

    if(isAddressInfoEmpty){
      const res = await add_profile_address(req);
      if (res.isSuccessFull) {
        await get_profile_account_information();
        SetStatus(false);
        system_alert_indicator({
          name: 'profile',
          message: `${addType === addressType.SHIP_TO?isWebUser ?'<b>Shipping Address</b> has been added successfully.':'Your request has been successfully submitted. New Shipping Address cannot be used and appear as a Shipping Address selection until it is verified.':'<b>Your Invoice Address</b> has been added successfully.'}`,
          type: "success"
        });
      }
    } else {
      const resp = await edit_profile_invoice_address(req);
      if (resp.isSuccessFull) {
        await get_profile_account_information();
        SetStatus(false);
        system_alert_indicator({
          name: 'profile',
          message: '<b>Your Invoice Address</b> has been updated successfully.',
          type: "success"
        });
      }
    }
  };

  const handleRadioChange = (index) => {
    setSelectedAddressIndex(index);
  };

  return (
    <div className="avnet-modal modal-600">
      <div className="avnet-modal-inner">
        <button type="button" className="close py-3" onClick={() => SetStatus(false)}>×</button>
        <div className="modal-header">
          <h4 className="modal-title text-center">Verify Your Address</h4>
        </div>
        <div className="modal-body">
          <div className='row bs5 px-4'>
            <div className='col-6'>
              {data?.suggestedAddress?.map((suggadd, index) => (
                <div key={index} className="radio">
                  <input
                    type="radio"
                    value={index}
                    id={index}
                    checked={selectedAddressIndex === index}
                    onChange={() => handleRadioChange(index)}
                  />
                  <div className='mb-3'>
                    <div className='companyname ps-0'>
                      <b>{data.suggestedAddress.length === 1 ? 'Suggested Address' : `Suggested Address ${index + 1}`}</b>
                    </div>
                    <div className='companyname ps-0'>{suggadd.company}</div>
                    <div className='companyaddress'>
                      {`${suggadd.address1}`} <br />
                      {/* {`${Helper.valueIsNotNull(suggadd.address2)?suggadd.address2:''}`} <br /> */}
                      {Helper.valueIsNotNull(suggadd.address2) && suggadd.address2.trim() && <>
                          {suggadd.address2}<br />
                      </>}
                      {`${suggadd.city}, ${suggadd.stateName} ${suggadd.postalCode}`} <br />
                      {suggadd.countryName}
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div className='col-6'>
              <div className="radio">
                <input
                  type="radio"
                  value="entered"
                  id="entered"
                  checked={selectedAddressIndex === -1}
                  onChange={() => handleRadioChange(-1)}
                />
                <div className='mb-3'>
                  <div className='companyname ps-0'><b>Entered Address</b></div>
                  <div className='companyname ps-0'>{data?.enteredAddress?.company}</div>
                  <div className='companyaddress'>
                    {`${data?.enteredAddress?.address1}`} <br/>
                    {/* {`${Helper.valueIsNotNull(data?.enteredAddress?.address2)?data?.enteredAddress?.address2:''}`} <br /> */}
                    {Helper.valueIsNotNull(data?.enteredAddress?.address2) && data?.enteredAddress?.address2.trim() && <>
                          {data?.enteredAddress?.address2}<br />
                    </>}
                    {`${data?.enteredAddress?.city}, ${data?.enteredAddress?.stateName} ${data?.enteredAddress?.postalCode}`} <br />
                    {data?.enteredAddress?.countryName}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer text-center">
          <button type="button" className="bs5 btn btn-secondary minw140" onClick={() => SetStatus(false)}>Cancel</button>
          <button type="button" className="bs5 btn btn-primary minw140" onClick={onSaveAddress}>Save</button>
        </div>
      </div>
    </div>
  );
};

export default VerifyAddressPopup;